'use client'

import { useState, useRef } from 'react'
import { signIn } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import Button from '@/components/Button'
import Link from 'next/link'
import { trackLogin } from '@/components/GoogleAnalytics'

export default function LoginForm() {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  
  const emailRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setError(null)
    
    const email = emailRef.current?.value
    const password = passwordRef.current?.value

    if (!email || !password) {
      setError('Preencha todos os campos.')
      return
    }

    setLoading(true)

    try {
      const res = await signIn('credentials', {
        redirect: false,
        email,
        password,
      })

      if (res?.error) {
        setError('Email ou senha inválidos.')
      } else {
        trackLogin('credentials')
        router.push('/')
        router.refresh()
      }
    } catch (err) {
      setError('Erro ao conectar com o servidor.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-white">Bem-vindo!</h2>
        <p className="text-zinc-400 text-sm mt-1">Entre para acessar seus ingressos</p>
      </div>

      <div>
        <label className="block text-sm font-medium text-zinc-300 mb-2">Email</label>
        <input
          ref={emailRef}
          type="email"
          className="w-full px-4 py-3.5 min-h-[48px] text-base bg-zinc-800/50 border border-zinc-700 rounded-xl text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#ffa300] focus:border-transparent transition-all"
          placeholder="seu@email.com"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-zinc-300 mb-2">Senha</label>
        <input
          ref={passwordRef}
          type="password"
          className="w-full px-4 py-3.5 min-h-[48px] text-base bg-zinc-800/50 border border-zinc-700 rounded-xl text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#ffa300] focus:border-transparent transition-all"
          placeholder="••••••••"
          required
        />
      </div>

      <div className="text-right">
        <Link 
          href="/esqueci-senha" 
          className="inline-block py-3 min-h-[44px] text-sm text-[#ffa300] hover:text-yellow-300 transition-colors"
        >
          Esqueci minha senha
        </Link>
      </div>

      <Button
        type="submit"
        disabled={loading}
        className="w-full"
      >
        {loading ? 'Entrando...' : 'Entrar'}
      </Button>

      {error && (
        <div className="p-3 bg-red-500/10 border border-red-500/50 rounded-lg text-red-400 text-sm text-center">
          {error}
        </div>
      )}
    </form>
  )
}

